<template>
  <a-config-provider :locale="locale">
    <div id="app" :style="{ background: !isBg ? 'linear-gradient(to right, #f1f1fe, #fff)' : 'none' }">
      <div class="back-style" :style="{ background: !isBg ? 'linear-gradient(rgba(67, 169, 241, 0.1215686275), rgba(255, 255, 255, 0.12), rgba(254, 254, 254, 0.03), rgba(248, 247, 254, 0.85))' : 'none' }"></div>
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
      isBg: false
    };
  },
  watch: {
    '$route'(to, from) {
      console.log('路由变化:', to, from);
      this.isBg = to.path.includes('login');
      if (!this.isBg){
        this.checkLogin()
      }
    }
  },
  methods:{
    // 判断用户是否登录,没有登录则跳转登录页面
    checkLogin() {
      if (Object.keys(this.$store.state.user.loginInfo).length === 0) {
        this.$message.warn('请重新登录!')
        this.$router.push('/login')
      }
    }
  },
  mounted() {

  },
  created() {

  }
}
</script>

<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  //background: linear-gradient(to right, #f1f1fe, #fff);

  >.back-style {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 0;
    //background: linear-gradient(rgba(67, 169, 241, 0.1215686275), rgba(255, 255, 255, 0.12), rgba(254, 254, 254, 0.03), rgba(248, 247, 254, 0.85));
  }
}

</style>
